<template>
    <el-dialog
        :model-value="modelValue"
        title="请选择升级文件"
        @open="handleOpen"
        @close="handleCancel"
        class="manDialog"
        width="800px"
        top="7vh"
    >
        <el-row class="user-list" :gutter="24">
            <el-col :span="24">
                <el-form
                    v-if="formVisible"
                    :inline="true"
                    class="search-form queryForm"
                    ref="search_form"
                    label-position="top"
                    :model="queryForm"
                    style="padding: 0"
                >
                    <el-form-item label="名称">
                        <el-input v-model="queryForm.name" clearable placeholder="请输入名称" style="width: 150px" />
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getListData">搜索</el-button>
                        <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                    </el-form-item>
                </el-form>

                <el-table
                    :data="tableListsData"
                    v-loading="tableLoading"
                    ref="multipleTableRef"
                    :row-key="(row) => row.id"
                    height="450px"
                    border
                    stripe
                >
                    <el-table-column label="序号" type="index" width="60" align="center" />
                    <el-table-column label="名称" align="center" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="版本" align="center" prop="version"></el-table-column>
                    <el-table-column
                        label="更新时间"
                        prop="update_time"
                        width="170"
                        align="center"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column prop="phone" label="操作" width="80" align="center">
                        <template #default="{ row }">
                            <el-button type="primary" link :icon="Check" size="small" @click="handleCheckFilesData(row)">
                                选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="pagination"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryForm.page"
                    :page-sizes="[5, 10, 20, 30]"
                    :page-size="queryForm.page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script setup>
import { ref, watch, onMounted, defineEmits, defineProps } from 'vue'
import { getUpgradeFileList } from '@/api/thermostat/devicePoint.js'
import { Search, Refresh, Check } from '@element-plus/icons'
import { ElMessageBox } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true
    },
    module: {
        type: String,
        required: true
    }
})

const emits = defineEmits(['update:modelValue', 'getSelectUpgrade'])

// 数据源
const queryForm = ref({
    kw: '',
    page: 1,
    page_size: 10,
    department: '',
    class: ''
})
const tableListsData = ref([])
const tableLoading = ref(false)
const total = ref(0)

const handleOpen = () => {
    console.log(props.selectCameraGroupId)
}

// 重置
const resetQueryForm = () => {
    Object.keys(queryForm.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size' && key !== 'module') queryForm.value[key] = ''
    })
    getListData()
}
const formVisible = ref(true)
// 获取列表数据
const getListData = async () => {
    tableLoading.value = true
    const result = await getUpgradeFileList({ ...queryForm.value, module: props.module })
    tableListsData.value = result.lists
    total.value = result.total
    tableLoading.value = false
}

const formDialogVisible = ref(false)
const selectId = ref('') // 点中的运营单位id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForm.value.page_size = currentSize
    getListData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForm.value.page = currentPage
    getListData()
}

// 被选择的人数据
const selectFilesData = ref({})

// 选择升级文件
const handleCheckFilesData = async (row) => {
    ElMessageBox.confirm(`您确定选择【${row.name}】升级吗？`, {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
    })
        .then(async () => {
            try {
                selectFilesData.value = row
                emits('getSelectUpgrade', selectFilesData.value)
                emits('update:modelValue', false)
            } catch (error) {}
        })
        .catch(() => {})
}

const handleCancel = () => {
    emits('update:modelValue', false)
}
// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getListData()
})
</script>
<style>
.manDialog .el-dialog__body {
    padding-top: 10px;
}
</style>

<style lang="scss" scoped>
.title {
    font-size: 16px;
    margin-bottom: 8px;
}
.treeContainer {
    height: 500px;
}

.headerSelectedContainer {
    font-size: 16px;
    display: flex;
    margin-bottom: 10px;
    width: 285px;
    height: 25px;
    box-sizing: border-box;
    border-bottom: 2px solid #e4e7ed;
    .manModelItem {
        line-height: 25px;
        height: 25px;
        color: #303133;
        padding: 0 20px;
        font-family: 'bullyingfheader-fist-title';
        border-bottom: 2px solid #e4e7ed;
        cursor: pointer;
        &.selected {
            background-color: #ecf5ff;
            border-bottom: 2px solid #409eff;
            color: #409eff;
            border-radius: 5px 5px 0 0;
        }
    }
}
</style>
